<div class="w-full">
  <mat-form-field class="fuse-mat-dense fuse-mat-rounded fuse-mat-no-subscript w-full [&_.mat-form-field-flex]:!min-h-[34px] [&_.mat-input-element]:!py-2">
    <mat-icon matPrefix class="icon-size-5" [svgIcon]="'heroicons_outline:search'"></mat-icon>
    <input
      #searchInput
      matInput
      type="text"
      maxlength="100"
      [attr.aria-label]="ariaLabel"
      [placeholder]="placeholder"
      [formControl]="searchControl"
      [matAutocomplete]="matAutocomplete"
    />
    <mat-progress-spinner
      *ngIf="isLoading"
      matSuffix
      [diameter]="16"
      [mode]="'indeterminate'"
    ></mat-progress-spinner>
    <span
      *ngIf="!isLoading && !hasText"
      matSuffix
      aria-hidden="true"
      class="ml-2 px-1.5 rounded border text-xs text-secondary whitespace-nowrap"
    >{{ shortcutLabel }}</span>
  </mat-form-field>
  <mat-autocomplete
    #matAutocomplete="matAutocomplete"
    class="max-h-128 mt-1 rounded"
    [panelWidth]="'28rem'"
    [displayWith]="displayTerm"
    [autoSelectActiveOption]="false"
    [disableRipple]="true"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-option *ngIf="isLoading" class="py-0 px-6 text-md text-secondary" [disabled]="true">
      Buscando…
    </mat-option>
    <mat-option *ngIf="!isLoading && hasError" class="py-0 px-6 text-md text-warn" [disabled]="true">
      No se pudo buscar
    </mat-option>
    <mat-option *ngIf="!isLoading && focused && focusLabel" class="py-0 px-6 text-sm text-secondary" [disabled]="true">
      Resultados de: {{ focusLabel }}
    </mat-option>
    <ng-container *ngIf="!isLoading && hasSearched && !groups.length">
      <mat-option *ngIf="!screens.length" class="py-0 px-6 text-md text-secondary" [disabled]="true">
        Sin resultados
      </mat-option>
      <mat-option *ngIf="!allProjects && !focused" class="py-0 px-6 text-md text-primary" [value]="allProjectsOption()">
        Buscar en todos los proyectos
      </mat-option>
    </ng-container>
    <ng-container *ngIf="!isLoading">
      <mat-optgroup *ngFor="let group of groups; trackBy: trackByGroup" [label]="group.label">
        <mat-option
          *ngFor="let item of group.items; trackBy: trackByItem"
          class="py-0 px-6 text-md"
          [value]="itemOption(group.key, item)"
        >
          <div class="flex items-center min-w-0">
            <mat-icon class="icon-size-5 mr-3 shrink-0 text-hint" [svgIcon]="groupIcons[group.key]"></mat-icon>
            <div class="flex flex-col min-w-0 leading-normal">
              <span class="truncate font-semibold">{{ item.title }}</span>
              <span *ngIf="item.subtitle || (allProjects && item.projectName)" class="truncate text-sm text-secondary">
                {{ item.subtitle }}<ng-container *ngIf="allProjects && item.projectName"><ng-container *ngIf="item.subtitle"> · </ng-container>{{ item.projectName }}</ng-container>
              </span>
            </div>
          </div>
        </mat-option>
        <mat-option class="py-0 px-6 text-sm text-primary" [value]="viewAllOption(group.key)">
          Ver todos
        </mat-option>
      </mat-optgroup>
      <mat-optgroup *ngIf="screens.length" [label]="'Funcionalidades'">
        <ng-container *ngFor="let match of screens; trackBy: trackByScreen">
          <mat-option class="py-0 px-6 text-md" [value]="routeOption(match.screen.route)">
            <div class="flex items-center min-w-0">
              <mat-icon class="icon-size-5 mr-3 shrink-0 text-hint" [svgIcon]="match.screen.icon"></mat-icon>
              <span class="truncate font-semibold">{{ match.screen.title }}</span>
            </div>
          </mat-option>
          <mat-option
            *ngFor="let functionality of match.functionalities; trackBy: trackByFunctionality"
            class="h-9 min-h-9 py-0 pl-14 pr-6 text-sm text-secondary leading-9"
            [value]="routeOption(functionality.route)"
          >
            <span class="truncate">{{ functionality.label }}</span>
          </mat-option>
        </ng-container>
      </mat-optgroup>
    </ng-container>
  </mat-autocomplete>
</div>
